import styled from '@emotion/styled';
import { keyframes } from '@emotion/core';

const expand = keyframes`
0% {
    transform: translateY(-100%);
    opacity: 0;
  }

100% {
    transform: translateY(0);
    opacity: 1;
  }
`;

export const DropdownDiv = styled.div(({ condition }) => ({
  animation: condition ? `${expand} 400ms ease-out` : '',
}));

export const ContainerDiv = styled.div`
overflow: hidden;
`;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseSchedulingChecklist/components/styledComponents.js